import React, { useState } from "react";
import { Modal, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { createProposal } from "../config/snapshot";

const CreateVoteModal = (props) => {
  const [form, setForm] = useState({
    title: "",
    description: "",
  });

  const [err, setErr] = useState({});
  const [loading, setLoading] = useState(false);

  const changeHandler = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const submitProposal = async () => {
    if (checkValidation()) {
      setLoading(true);
      try {
        const { title, description } = form;
        await createProposal(title, description);
        
        // Reset form
        setForm({ title: "", description: "" });
        setErr({});
        
        // Close modal
        props.setShowModal(false);
        
        // Trigger refresh of proposals in parent components
        if (props.onProposalCreated) {
          props.onProposalCreated();
        }
        
      } catch (error) {
        console.error("Proposal submission failed:", error);
        const errorMessage = error?.message || error?.error_description || "Failed to create proposal. Please try again.";
        toast.error(errorMessage);
        setErr({ submit: errorMessage });
      } finally {
        setLoading(false);
      }
    }
  };

  const checkValidation = () => {
    let errData = {};
    if (!form?.title || form?.title.trim().length === 0) {
      errData.title = "Title must not be empty.";
    }
    if (!form?.description || form?.description.trim().length === 0) {
      errData.description = "Description must not be empty.";
    }

    setErr(errData);
    return Object.keys(errData).length === 0;
  };

  const handleClose = () => {
    // Reset form and errors when closing
    setForm({ title: "", description: "" });
    setErr({});
    props.setShowModal(false);
  };

  return (
    <Modal {...props} size="md" centered>
      <Modal.Body>
        <div className="modal-header">
          <div className="title">Create Vote</div>
          <button type="button" onClick={handleClose}>
            <img src="/images/close.svg" alt="close icon" />
          </button>
        </div>

        <Form.Group className="mb-3" controlId="formTitle">
          <Form.Label>Title</Form.Label>
          <Form.Control
            type="text"
            name="title"
            placeholder="Enter Title"
            value={form.title}
            onChange={changeHandler}
            disabled={loading}
          />
          {err?.title && <p className="text-danger">{err.title}</p>}
        </Form.Group>

        <Form.Group className="mb-3" controlId="formDescription">
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Enter Description"
            name="description"
            value={form.description}
            onChange={changeHandler}
            disabled={loading}
          />
          {err?.description && <p className="text-danger">{err.description}</p>}
        </Form.Group>

        {err?.submit && (
          <div className="alert alert-danger" role="alert">
            {err.submit}
          </div>
        )}

        <div className="d-flex justify-content-end gap-2">
          <button
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={submitProposal}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                &nbsp;Creating...
              </>
            ) : (
              "Create Proposal"
            )}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateVoteModal;